import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
import {IsStatusEnum, Level, TaskStatusEnum, TaskTypeEnum} from './constant'

// [获取女用户等级中心页] http://wiki.xunlei.cn/display/zdxm/fetch_female_reward_page
export const homepage = createAsyncThunk(
  'Saada/live/hiya_socialize/fetch_female_reward_page',
  async (arg, store: any) => {
    const resp = await http.post(
      '/live/hiya_socialize/fetch_female_reward_page',
      {
        ...store.getState().env.otherInfo,
      },
      {
        store,
      }
    )
    return resp.data.data
  }
)

// [获取女用户新手页] http://wiki.xunlei.cn/display/~chenfeng8/fetch_female_novice_page
export const newUserTaskHomepage = createAsyncThunk(
  'Saada/live/hiya_socialize/fetch_female_novice_page',
  async (arg, store: any) => {
    const resp = await http.post(
      '/live/hiya_socialize/fetch_female_novice_page',
      {
        ...store.getState().env.deviceinfo,
      }
    )
    return resp.data.data
  }
)

// [等级中心页或者新手任务页领取奖励] http://wiki.xunlei.cn/display/~chenfeng8/acquire_female_task_reward
export const acquire_female_task_reward = createAsyncThunk(
  'Saada/live/hiya_socialize/acquire_female_task_reward',
  async (
    arg: {
      task_id?: string // 任务id，每日任务或者新手任务上报
      task_type: TaskTypeEnum // 任务类型，新手任务"novice_task",每日任务"daily_task",周任务"weekly_task"
      task_level: string // 任务等级，"N","B","A","S","SS"
      task_param?: number // 任务参数，周任务上报
    },
    store: any
  ) => {
    const resp = await http.post(
      '/live/hiya_socialize/acquire_female_task_reward',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      }
    )
    return resp.data.data
  }
)

interface IBenefits {
  benefit_icon: string
  reward_cnt: number
}
interface ILevelInfo {
  upgrade_standard: number // 升级所需奖励数
  fast_upgrade_standard: number // 快升所需奖励数
  degrade_standard: number // 保级所需收益
  level_benefits: {
    // 等级权益
    daily_reward: IBenefits
    exposure: IBenefits
    weekly_reward: IBenefits
  }
}
interface IHome {
  user_level: Level // N、B、A、S、SS
  task_level: Level // N、B、A、S、SS
  is_fast_upgrade: IsStatusEnum // 当前是否快升通道
  fast_upgrade_tip?: IsStatusEnum // 快升弹窗展示
  upgrade_tip: IsStatusEnum // 升级弹窗展示
  total_reward: number // 当周累计收益
  week_remain_ts?: number // 周剩余时间，单位为s
  daily_tasks: IDailyTask[] // 每日任务
  room_tasks: IDailyTask[] // 每日任务
  week_tasks: {
    [key in Level]: IWeeklyTask[]
  }
  // 每周任务
  level_infos: {
    [key in Level]: ILevelInfo
  }
  need_auth: boolean // 为true时跳到认证提示页
}

interface IWeeklyTask {
  task_level: string // 任务等级
  task_param: number // 任务要求
  reward_type: number // 奖励类型，1：珍珠
  reward_icon: string // 奖励icon
  reward_cnt: number // 奖励数量
  task_complete_cnt: number // 任务完成次数，0或者1
  task_status: TaskStatusEnum
}

interface INewUserTaskHome {
  user_level: Level // N、B、A、S、SS
  novice_tip: number // 1:给动效，0:无动效
  novice_task_reward: number // 新手任务累计收益
  daily_task_reward: number // 当日累计收益
  weekly_task_reward: number // 当周累计收益
  novice_tasks: IDailyTask[]
  level_infos: {
    [key in Level]: ILevelInfo
  }
}

export interface IDailyTask {
  task_id: string // 任务id
  task_name: string // 任务内容
  task_level: string // 任务等级
  jump_url: string // 跳转链接
  task_icon: string // 任务icon
  reward_type: number // 奖励类型，1：珍珠
  reward_cnt: number // 奖励数量
  subtask_need_cnt: number // 单次任务目标完成次数
  subtask_cur_cnt: number // 单次任务累计完成次数
  task_status: TaskStatusEnum
}

export interface InitialStateType {
  home?: Partial<IHome>
  newUserTaskHome?: Partial<INewUserTaskHome>
}

const initialState: InitialStateType = {
  home: {},
  newUserTaskHome: {},
}

export const LevelCenterSlice = createSlice({
  name: 'LevelCenter',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(homepage.fulfilled, (state, action) => {
      Object.assign(state, {home: action.payload})
    })

    builder.addCase(newUserTaskHomepage.fulfilled, (state, action) => {
      Object.assign(state, {newUserTaskHome: action.payload})
    })
  },
})
export default LevelCenterSlice.reducer
export const LevelCenterActions = LevelCenterSlice.actions

export const useLevelCenterState = () => {
  const data = useSelector((state) => {
    return state.SaadaLevelCenter
  })
  return data
}
